export const GalleryId = 'product-page-hero-carousel';
